module.exports = __webpack_public_path__ + "img/dn-icon.44aaf80c.svg";